import { render, staticRenderFns } from "./risk_nation.vue?vue&type=template&id=f3619c48&scoped=true"
import script from "./risk_nation.vue?vue&type=script&lang=js"
export * from "./risk_nation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3619c48",
  null
  
)

export default component.exports